import { useRef, useState, useEffect } from 'react'
import { AppState } from 'react-native'

export function useAppState() {
  const appState = useRef(AppState.currentState)
  const [appStateVisible, setAppStateVisible] = useState<boolean>(appState.current === 'active')

  useEffect(() => {
    const subscription = AppState.addEventListener('change', (nextAppState) => {
      if (appState.current.match(/inactive|background/) !== null && nextAppState === 'active') {
        //  App has come to the foreground
        setAppStateVisible(true)
      } else {
        setAppStateVisible(false)
      }

      appState.current = nextAppState
    })

    return () => {
      subscription.remove()
    }
  }, [])

  return {
    isAppVisible: appStateVisible,
    state: appState.current,
  }
}

export default useAppState
